import { dayjs } from '@2wunder/klarx-tool'
import { Row } from 'antd'
import InvoiceOverviewTable from 'app/components/Core/Invoice/OverView/Table'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import useTitle from 'app/lib/hooks/useTitle'
import { PageProps } from 'app/pages/typing'
import React from 'react'

const periodTo = dayjs()
const periodFrom = periodTo.subtract(3, 'month')

const defaultFilters = {
  periodFrom: periodFrom.toISOString(),
  periodTo: periodTo.toISOString()
}

const Index: React.FC<PageProps> = (props) => {
  const { title } = useTitle(props)

  return (
    <Row gutter={[0, 24]}>
      <KCol span={24} card title={title}>
        <InvoiceOverviewTable defaultFilters={defaultFilters} />
      </KCol>
    </Row>
  )
}

export default Index
